


















































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import DateUtils from '@/common/js/DateUtils'
import Enums from '@/lib/enums'
import { routers } from '@/router/router'
// import { getLodop, demoDownloadPDF } from '@/common/js/LodopFuncs'
import { classPrintWorld } from '@/common/js/PrintWorld'
import UpdatebackstockorderStatu from '@/store/entities/back-updatestatus'
import EditShipment from './order-editshipment.vue'
import AddShipment from './order-addshipment.vue'
import UpdateOderStatu from './update-stockorder-status.vue'
import BaleStockOrder from './bale-stockorder.vue'
import Weight from './Weighing-input.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list'
import moment from 'moment'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(Preview);
import VueClipboard from 'vue-clipboard2'
import { Select } from '../../../types/iview/select';
Vue.use(VueClipboard)


class PageOrderRequest extends PageRequest {
    storeId: number;
    orderStatus?: number;
    packageStatus?: number;
    SearchInfo: string;
    userCode: string;
    BeginTime?: Date;
    EndTime?: Date;
    manlandPackageName: string;
    packedBeginTime?: Date;
    packedEndTime?: Date;
    tradeNo: string;
    site?: number;
    isUrgent?: boolean;
    isSingle?: boolean;
    PlatformType?: number;
    productId?: number;
    productorderStatu?: number;
    constructor() {
        super();
        this.orderStatus = null;
        this.packageStatus = null;
        this.isUrgent = null;
        this.isSingle = null;
    }
}

@Component({
    name: "backstockorder",
    components: { BaleStockOrder, UpdateOderStatu, Weight, EditShipment, AddShipment }

})
export default class Orders extends AbpBase {
    pagerequest: PageOrderRequest = new PageOrderRequest();
    creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    receivedTime: Date[] = [];
    orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
    packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
    siteType = Enums.getEnum(Enums.SiteSType, true);
    PlatformType = Enums.getEnum(Enums.PlatformType, true);
    urgentStatus = Enums.getEnum(Enums.WhetherHandleStatus, true);
    productorderList = Enums.getEnum(Enums.ProductOrderStatus, true);
    updateOderStatuShow = false;
    isPdfData = false;
    editModalShow: boolean = false;
    automaticJump: boolean = false;
    isLoadPrintList: boolean = false;
    weightShow: boolean = false;
    flag: boolean = false;
    baleStockOrderModal: boolean = false;
    editShipmentModalShow: boolean = false;
    orderNumberList: string[] = [];
    logisticsList: string[] = [];
    BaseSkuNums: number[] = [];
    AddModalShow: boolean = false;
    packedTime: Date[] = [];
    storeaddressList: Array<storeaddressInfo> = [];
    get list() {
        return this.$store.state.backstockorder.list;
    };
    get loading() {
        return this.$store.state.backstockorder.loading;
    }
    pageChange(page: number) {
        this.$store.commit('backstockorder/setCurrentPage', page);
        this.getpage();
    }
    handleChangeImg($event) {
        if ($event.currentTarget.className == 'img') {
            $event.currentTarget.className = 'img open';
        } else {
            $event.currentTarget.className = 'img';
        }
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('backstockorder/setPageSize', pagesize);
        this.getpage();
    }

    @Watch('$route.params.inputShipment')
    inputShipmentChange() {
        var s = '';
        if (this.$route.params.inputShipment) {
            this.pagerequest = new PageOrderRequest();
            this.pagerequest.SearchInfo = this.$route.params.inputShipment;
            this.$store.state.backstockorder.currentPage = 1;
            this.getpage();
        }

    }

    async printSelect() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        for (var i = 0; i < selection.length; i++) {
            var printResult =  this.printPdf(selection[i]);
            if (!printResult) {
                break;
            }
        }

    }


    formatShelfData(data): any {
        // 1. 计算总数
        const totalCount = data.reduce((sum, item) => sum + item.count, 0);

        // 2. 定义格式化函数
        const formatTotal = (str) => str.padEnd(13, ' '); // Total固定13字符
        const formatShelf = (str) => str.padEnd(20, ' '); // 货架固定20字符

        // 3. 生成所有货架信息
        const shelfItems = data.map(item =>
            formatShelf(`${item.shelfPosition}_${item.productId} * ${item.count}`)
        );

        // 4. 构建输出行
        let output = [];

        // 第一行：Total + 前2个货架
        if (shelfItems.length > 0) {
            let firstLine = formatTotal(`Total: ${totalCount}`);
            if (shelfItems.length >= 1) firstLine += shelfItems[0];
            if (shelfItems.length >= 2) firstLine += shelfItems[1];
            output.push(firstLine);
        }

        // 后续行：每行2个货架（前面补13空格）
        for (let i = 2; i < shelfItems.length; i += 2) {
            let line = ' '.repeat(17); // 补13空格对齐
            if (shelfItems[i]) line += shelfItems[i];
            if (shelfItems[i + 1]) line += shelfItems[i + 1];
            output.push(line);
        }

        // 5. 用逗号连接所有行
        return output.join(',');
}

     getPdfUrl(data): any {
        var pdfData: any = {};
        pdfData.pdfGuid = data.pdfGuid;
        pdfData.userId = data.userId;
        pdfData.orderNumber = data.orderNumber;
        pdfData.pdfdata = this.isPdfData;
        if (this.isPdfData) {
            var store = this.storeaddressList.find(c => c.storeName == data.storeName);
            // 国内不处理
            if (store.whetherLocal) {
                pdfData.pdfdata = false;
            } else {
                //var infos = new Array();
                //var i = 0;
                //i
                //var sumCount = 0;
                //for (const item of data.productInfos) {
                //    sumCount += item.count;
                //}
                //for (const item of data.productInfos) {
                //    if (i == 0) {
                //        infos.push("Tatal:"+item.shelfPosition + "_" + item.productId + " * " + item.count);
                //    } else {
                //        infos.push(item.shelfPosition + "_" + item.productId + " * " + item.count);
                //    }
                //    i++;
                //}
                //pdfData.infos = infos.join(',');
                pdfData.infos = this.formatShelfData(data.productInfos);
                if (data.tradeNo.startsWith("68")) {
                    pdfData.heightPercentage = 100;
                } else {
                    pdfData.heightPercentage = 69;
                }
            }
         }
         this.$store.commit('fontorder/getZDYPdfUrl', pdfData);
         return pdfData;
    }

    //async weighing() {
    //    this.updatePackageStatus(3);
    //}
    //async cancelpacked() {
    //    this.updatePackageStatus(8);
    //}


    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (this.storeaddressList.length == 1) {
            this.pagerequest.storeId = this.storeaddressList[0].id;
        }
        else {
            this.storeaddressList.push(a);
            this.pagerequest.storeId = null;
        }
    }
    async Newpacked(data: any) {
        this.$store.state.backstockorder.id = data.id;
        this.$store.state.backstockorder.BaseSkuNums = data.productInfos.length;
        this.$store.state.backstockorder.cargoCategory = data.cargoCategory;
        this.$store.state.backstockorder.orderNumber = data.orderNumber;
        this.$store.state.backstockorder.automaticJump = this.automaticJump;
        this.$store.state.backstockorder.tradeNo = data.tradeNo;
        if (data.whetherNeedWeighing) {
            this.weightShow = true;
        }
        else {
            this.baleStockOrderModal = true;
        }

    }

    async arriveWarehouse() {

        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        var ids = [];

        for (var i = 0; i < selection.length; i++) {
            ids.push(selection[i].id);
            if (i + 1 < selection.length) {
                if (selection[i].cargoCategory != selection[i + 1].cargoCategory) {
                    this.$Message.error("选中的数据中货物类别不一致！");
                    return;
                }
            }
        }

        this.$store.state.backstockorder.ids = ids;
        this.$store.state.backstockorder.cargoCategory = selection[0].cargoCategory;
        // this.updatePackageStatus(2);
        this.AddModalShow = true;
    }
    async cancelBale() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        this.$Modal.confirm({
            title: "取消打包", content: "确认批量将订单取消打包？", onOk: async () => {
                var ids = [];
                for (var i = 0; i < selection.length; i++) {
                    ids.push(selection[i].id);
                }
                await this.$store.dispatch({
                    type: 'backstockorder/cancleBale',
                    data: { ids: ids }
                });
                this.getpage();

            }
        });
    }


    //async arriveWarehouse() {
    //    this.updatePackageStatus(4);
    //}

    async AllarriveWarehouse() {
        var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == 4 })[0].name;
        this.$Modal.confirm({
            title: "一键送仓", content: "确认批量将包裹状态处理为【" + statuName + "】？", onOk: async () => {
                await this.$store.dispatch({
                    type: 'backstockorder/oneClickDelivery',
                    data: {}
                });
                this.getpage();
            }
        });

    }
    async exportexpress() {
        await this.$store.dispatch({
            type: 'backstockorder/impotExcel',
            data: this.pagerequest
        })
    }
    //async pendingWarehouse() {
    //    this.updatePackageStatus(6);
    //}
    //async updatePackageStatus(statu: number) {
    //    var selectionData: any = this.$refs.selection;
    //    var selection = selectionData.getSelection();
    //    if (!selection || selection.length == 0) {
    //        this.$Message.error("选中项不能为空！");
    //        return;
    //    }
    //    var statuName = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == statu })[0].name;

    //    this.$Modal.confirm({
    //        title: "修改包裹状态", content: "确认批量将此订单处理为" + statuName + "？", onOk: async () => {
    //            var ids = [];
    //            for (var i = 0; i < selection.length; i++) {
    //                ids.push(selection[i].id);
    //            }
    //            await this.$store.dispatch({
    //                type: 'backstockorder/updatePackageStatus',
    //                data: { ids: ids, PackageStatus: statu, orderType: this.pagerequest.OrderType }
    //            });
    //            this.getpage();

    //        }
    //    });
    //}
    async getpage() {
        if (this.creationTime.length > 0) {
            this.pagerequest.BeginTime = this.creationTime[0];
        } else {
            this.pagerequest.BeginTime = null;
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.EndTime = this.creationTime[1];
        } else {
            this.pagerequest.EndTime = null;
        }
        if (this.packedTime.length > 0) {
            this.pagerequest.packedBeginTime = this.packedTime[0];
        } else {
            this.pagerequest.packedBeginTime = null;
        }
        if (this.packedTime.length > 1) {
            this.pagerequest.packedEndTime = this.packedTime[1];
        } else {
            this.pagerequest.packedEndTime = null;
        }
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

        await this.$store.dispatch({
            type: 'backstockorder/getAll',
            data: this.pagerequest
        });

        var _this: any = this;
        _this.$previewRefresh();
    }

    async searchPage() {
        this.$store.state.backstockorder.currentPage = 1;
        this.getpage();
    }

    get pageSize() {
        return this.$store.state.backstockorder.pageSize;
    }
    get totalCount() {
        return this.$store.state.backstockorder.totalCount;
    }
    get currentPage() {
        return this.$store.state.backstockorder.currentPage;
    }
    async operationData(name: any, data: any) {
        if (name == "复制订单编号") {
            this.copyInfo(data.orderNumber);
        }
        else if (name == "复制快递单号") {
            var stringList: Array<string> = [];
            data.logistics.forEach(function (element) {
                stringList.push(element.shipment);
            });
            this.copyInfo(stringList.join("/"));
        }
        else if (name == '标记为异常') {
            var updateData = new UpdatebackstockorderStatu();
            updateData.id = data.id;
            updateData.orderStatus = -1;
            updateData.reMark = data.warehouseNote;
            updateData.orderNumber = data.orderNumber;
            this.$store.state.backstockorder.updateOrdeData = updateData;
            this.updateOderStatuShow = true;
        } else if (name == '标记为正常') {
            var updateData = new UpdatebackstockorderStatu();
            updateData.id = data.id;
            updateData.orderStatus = 0;
            updateData.reMark = data.warehouseNote;
            updateData.orderNumber = data.orderNumber;
            updateData.abnormalImageUploadGuid = data.abnormalImageUploadGuid,
                this.$store.state.backstockorder.updateOrdeData = updateData;
            this.updateOderStatuShow = true;
        }
        else if (name == '撤销订单') {
            await this.$store.dispatch({
                type: 'backstockorder/cancleStockOrder',
                data: { stockOrderId: data.id }
            });
            this.getpage();
        }
        else if (name == "修改本土包裹") {
            this.$store.state.backstockorder.packageName = data.packageName;
            this.$store.state.backstockorder.id = data.id;
            this.$store.state.backstockorder.cargoCategory = data.cargoCategory;
            this.editShipmentModalShow = true;
        } else if (name == '撤销急单') {
            await this.$store.dispatch({
                type: 'backstockorder/cancelUrgentOrder',
                data: { stockOrderId: data.id }
            });
            this.getpage();
        }
    }

    copyInfo(data) {
        var _this = this;
        this.$copyText(data).then(function (e) {
            _this.$Message.success("复制成功");
        }, function (e) {
            _this.$Message.error("复制失败");
        });
    }
    printPdf(data) {

        if (!this.isLoadPrintList) {
            var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
            var json = {
                action: "", refresh: true, defaultprn: true, error: "", val: {}
            };
            json.action = "printers";
            json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
            json.defaultprn = true;                   //是否包含缺省打印机信息。
            json = printWorld.Direct(json);
            if (json == null) {//数据发送失败
                alert(printWorld.GetLastError());
            } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                alert(json.error);
            } else {    //处理包含打印机列表的json
            }


            var Options = new Array();
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('SelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return false;
        }


        var pdfUrl = this.getPdfUrl(data);
        var printSelect: any = document.querySelector('#SelectPrint');
        if (!printSelect.value) {
            this.$Message.success("请选择指定打印机");
            return false;
        }
        if (pdfUrl.url && pdfUrl.url.length > 0) {
            var printWorld = new classPrintWorld(); //new 一个打天下对象
            var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
            jsons.action = "printfile";
            jsons.format = "pdf_url";        //指定格式为pdf_url。
            jsons.content = pdfUrl.url;   //pdf文件的url路径
            if (pdfUrl.pdfdata == true) {
                jsons.paperlength = 140;
                jsons.paperwidth = 100;
            } else {
                jsons.paperlength = 15;
                jsons.paperwidth = 10;
            }
            jsons.cert = "https://tkyc.ddtmx.com/cer/fileprintauth.ctf";
            jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
            printWorld.Direct(jsons);
            return true;
        }
        return false;
    }



    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center',

        }, {
            title: '订单编号',
            key: 'orderNumber',
            width: 170,
        },
        {
            title: '运单号',
            key: 'tradeNo',
            width: 150,
        },
        {
            title: '退货单号',
            key: 'returnNumber',
            width: 150,
        },
        {
            title: '产品编号',
            key: 'productInfos',
            width: 200,
            render: (h: any, params: any) => {
                var _this = this;
                var a = "";
                if (params.row.reMark) {
                    a = 'red';
                }
                else {
                    a = 'dark';
                }
                return h('div', [
                    h('ul', params.row.productInfos.map(item => {
                        return h('li', {
                        }, [
                            item.productNo, h('h2', { style: { color: 'red' } }, (item.shelfPosition ? item.shelfPosition : "") + "_" + item.productId)])
                    }))

                ])

            }
        },
        {
            title: '站点',
            width: 90,
            key: 'site',
            render: (h: any, params: any) => {
                return h('h3', { style: { color: "red", display: "inline-block" } }, Enums.ShopSiteType.filter(function (item) { return item.value == params.row.site })[0].name);
            }

        },
        {
            title: '物流方式',
            width: 90,
            key: 'site',
            render: (h: any, params: any) => {
                return h('h3', { style: { color: "red", display: "inline-block" } }, ((params.row.shippingMethods == "Wise Express") ? params.row.shippingMethods : ""));

            }
        }, {
            title: '是否急单',
            width: 90,
            key: 'isUrgent',
            render: (h: any, params: any) => {
                return h('span', params.row.isUrgent ? "是" : "否",
                )
            }
        },
        {
            title: '订单时效',
            width: 120,
            key: 'orderPayTime',
            render: (h: any, params: any) => {
                var info = "";
                var color = "red";
                if (params.row.orderPayTime) {
                    var currentTime: any = new Date();
                    var payTime: any = new Date(params.row.orderPayTime);
                    var timeDifferenceInHours = (currentTime - payTime) / (60 * 60 * 1000);
                    timeDifferenceInHours = Math.round(timeDifferenceInHours * 10) / 10;
                    if (timeDifferenceInHours < 90) {
                        color = "green";
                    }
                    info = timeDifferenceInHours.toString();

                }
                return h('h3', { style: { color: color, display: "inline-block" } }, info);

            }
        },
        {
            title: '订单状态',
            width: 100,
            key: 'orderStatus',
            render: (h: any, params: any) => {
                var warehouseNote = params.row.warehouseNote;
                if (warehouseNote) {
                    warehouseNote = "(" + warehouseNote + ")";
                }
                else {
                    warehouseNote = "";
                }
                return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                )
            }
        },
        {
            title: '产品订单状态',
            width: 110,
            key: 'productOrderStatus',
            render: (h: any, params: any) => {
                if (params.row.productOrderStatus != 2) {
                    return h('div', [h('p', { style: { color: 'red' } }, Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name)])
                }
                else {
                    return h('span', Enums.ProductOrderStatus.filter(function (item) { return item.value == params.row.productOrderStatus })[0].name,
                    )
                }

            }
        },
        //{
        //    title: '备注',
        //    width: 200,
        //    key: 'reMark',
        //    render: (h: any, params: any) => {
        //        return h('div', [h('span', { style: { color: 'red' } }, params.row.reMark)]
        //        )
        //    }
        //},
        {
            title: '商品信息',
            width: 300,
            key: 'productInfos',
            render: (h: any, params: any) => {
                var _this = this;
                var a = "";
                if (params.row.reMark) {
                    a = 'red';
                }
                else {
                    a = 'dark';
                }
                return h('div', [
                    h('ul', params.row.productInfos.map(item => {
                        var data = { imageGuid: item.productImgGuid, url: null };
                        var url = "";
                        var productInfo = item.productName;
                        if (item.productSku) {
                            productInfo = item.productSku;

                        }
                        if (item.productImgGuid.indexOf("http") != -1) {
                            url = item.productImgGuid;
                        }
                        else {
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            url = data.url;
                        }
                        return h('li', {
                        }, [
                            h('img', {
                                style: {
                                    width: "50px",
                                    height: "50px",
                                    verticalAlign: "middle"
                                },
                                attrs: {
                                    src: url,
                                    preview: "tp_" + item.stockOrderProductId,
                                    "preview-text": item.stockOrderProductId + "img"

                                }
                            }), (productInfo), h('font', { style: { color: "red" } }, '---'), h('h1', { style: { color: "#000099", display: "inline-block" } }, item.count)])
                    })), h('h4', { style: { color: a } }, "备注：" + (params.row.reMark == null ? "" : params.row.reMark))

                ])

            }
        },
      
        {
            title: '包裹状态',
            width: 90,
            key: 'packageStatus',
            render: (h: any, params: any) => {
                return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
            }
        },
        {
            title: '是否需要称重',
            key: 'whetherNeedWeighing',
            width: 90,
            render: (h: any, params: any) => {
                return h('span', params.row.whetherNeedWeighing ? "是" : "否");
            }
        },
        {
            title: '异常图片',
            key: 'abnormalImageUploadGuid',
            width: 95,
            render: (h: any, params: any) => {
                if (params.row.abnormalImageUploadGuid) {
                    var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                    this.$store.commit('expressuserinfo/getImgUrl', data);
                    var url = data.url;;
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: "yc_" + params.row.id,
                            "preview-text": params.row.orderNumber + "异常图片"
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
        {
            title: '包裹基本信息',
            key: '',
            width: 250,
            render: (h: any, params: any) => {
                return h('div', [h('h3', ("长：" + (params.row.long == null ? "" : params.row.long) + "cm," + "宽：" + (params.row.wide == null ? "" : params.row.wide) + "cm," + "高：" + (params.row.high == null ? "" : params.row.high) + "cm")), h('h3', "体积重:" + (params.row.bulkyByClient == null ? "" : params.row.bulkyByClient)), h('h3', "重量重:" + (params.row.heavyWeight == null ? "" : params.row.heavyWeight)), h('h3', "实际计算重量:" + (params.row.weight == null ? "" : params.row.weight))])
            }
        },

        {
            title: '费用',
            width: 200,
            render: (h: any, params: any) => {
                var a = "";
                var b = "";
                var c = "";
                var d = "";
                var e = "";
                var f = "";
                if (params.row.isPay) {
                    a = 'red';
                }
                else {
                    a = 'dark';
                }
                if (params.row.freightCost) {
                    b = 'red';
                }
                else {
                    b = 'dark';
                }
                if (params.row.extraCost) {
                    c = 'red';
                }
                else {
                    c = 'dark';
                }
                if (params.row.extraCostDescribe) {
                    d = 'red';
                }
                else {
                    d = 'dark';
                }
                if (params.row.sackTotalAmount > 0) {
                    e = 'red';
                }
                else {
                    e = 'dark';
                }
                if (params.row.skuTotalAmount > 0) {
                    f = 'red';
                }
                else {
                    f = 'dark';
                }
                return h('div', [h('h3', { style: { color: a } }, "是否支付:" + (params.row.isPay ? this.L('是') : this.L('否'))), h('h3', { style: { color: e } }, "打包袋金额:" + (params.row.sackTotalAmount == null ? "" : params.row.sackTotalAmount)), h('h3', { style: { color: f } }, "SKU金额:" + (params.row.skuTotalAmount == null ? "" : params.row.skuTotalAmount)), h('h3', { style: { color: f } }, "运费:" + (params.row.freightCost == null ? "" : params.row.freightCost))])
            }
        },
        {
            title: '平台物流号',
            key: 'tradeNo',
            width: 130,
        },
        {
            title: '仓储名称',
            key: 'storeName',
            width: 100,
        },
        {
            title: '采购订单编号',
            key: 'logistics',
            width: 200,
            render: (h: any, params: any) => {
                return h('ul', params.row.logistics.map(item => {
                    return h('li', {
                        domProps: {
                            innerHTML: '<span> ' + (item.purchaseOrderNumber ? item.purchaseOrderNumber : "") + ' </span>'
                        }
                    });
                }));
            }
        }, {
            title: '本土包裹名称',
            key: 'packageName',
            width: 200,
        },

        {
            title: '货运单号',
            key: 'waybillNumber',
            width: 120,
        },

        {
            title: '时间',
            width: 250,
            render: (h: any, params: any) => {
                return h('div', [h('h3', "创建时间:" + (params.row.createTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.createTime)))), h('h3', "更新时间:" + (params.row.updateTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.updateTime)))), h('h3', "打包时间:" + (params.row.packedTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.packedTime)))), h('h3', "送仓时间:" + (params.row.arriveWarehouseTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime))))])
            }
        },
        {
            title: '打包袋数量',
            key: 'sackNums',
            width: 80,
        },
        {
            title: '基本SKU数量',
            key: 'baseSkuNums',
            width: 80,
        }, {
            title: '用户编号',
            key: 'userCode',
            width: 90,
        }, {
            title: '打包人',
            key: 'packedUserName',
            width: 80,
        }, {
            title: '原始信息',
            key: 'isCombination',
            width: 230,
            render: (h: any, params: any) => {
                if (!params.row.combinationProductInfos || params.row.combinationProductInfos.length === 0) {
                    return h('span', { style: { color: '#c5c8ce' } }, '');
                }

                return h('div', params.row.combinationProductInfos.map((item: any) => {
                    return h('div', {
                        style: {
                            marginBottom: '4px',
                            fontSize: '12px',
                            lineHeight: '1.4'
                        }
                    }, [
                        h('span', {
                            style: {
                                color: '#515a6e',
                                fontWeight: 'bold'
                            }
                        }, item.productNo || '未知'),
                        h('font', {
                            style: {
                                color: 'red',
                                margin: '0 2px'
                            }
                        }, '*'),
                        h('span', {
                            style: {
                                color: '#808695'
                            }
                        }, `${item.count || 0}`)
                    ]);
                }));
            }
        },

        {
            title: '操作',
            width: 100,
            fixed: 'left',
            key: 'id',
            render: (h: any, params: any) => {
                var data = params.row;
                var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                var productOrderStatusName = "";
                if (data.productOrderStatus != null) {
                    productOrderStatusName = Enums.ProductOrderStatus.filter(function (item) { return item.value == data.productOrderStatus })[0].name;
                }
                var orderStatus = Enums.WarehouseOrderStatus.filter(function (item) { return item.value == data.orderStatus })[0].name;
                var _this = this;
                var menu = [];
                //if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                //    menu.push("查看Pdf");
                //}
                if (params.row.packageStatus == 4) {
                    menu.push("修改本土包裹");
                }
                if (params.row.orderStatus == 0 && params.row.packageStatus != 5) {
                    menu.push("标记为异常");
                }
                if (params.row.orderStatus == -1 && params.row.packageStatus != 5) {
                    menu.push("标记为正常");
                }
                if (params.row.orderStatus == -1) {
                    menu.push("撤销订单");
                }
                if (params.row.isUrgent) {
                    menu.push("撤销急单");
                }
                menu.push("复制订单编号");
                if (params.row.logistics && params.row.logistics.length > 0) {
                    menu.push("复制快递单号");
                }

                return h('div', [
                    h('Dropdown', {
                        props: {
                            transfer: true,
                            trigger: 'click',
                        },
                        on: {
                            'on-click': (name) => {
                                _this.operationData(name, params.row);
                            }
                        }

                    }, [
                        h('Button',
                            {
                                domProps: {
                                    innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                },
                                props: {
                                    type: 'primary',
                                }

                            }),

                        h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                            return h('DropdownItem', { props: { name: item } }, item)
                        })
                        )],
                    ),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            height: '30px',
                            width: '68px',
                        },
                        on: {
                            click: () => {
                                var data = params.row;
                                var _this = this;
                                var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                if (packageStatus != "已收货") {
                                    this.$Modal.confirm({
                                        title: "打印PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否打印此订单的面单？", onOk: async () => {
                                            _this.printPdf(data);
                                        }
                                    });
                                }
                                else {
                                    _this.printPdf(data);
                                }
                            }
                        }
                    }, "打印PDF"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            height: '30px',
                            width: '68px',
                        },
                        on: {
                            click: () => {
                                var data = params.row;
                                var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                                if (packageStatus != "已收货") {
                                    this.$Modal.confirm({
                                        title: "查看PDF", content: "此订单包裹为【" + packageStatus + "】状态，不是【已收货】，是否查看此订单的面单？", onOk: async () => {
                                            var url = this.getPdfUrl(data).url;
                                            window.open(url);
                                            //this.$store.commit('fontorder/getPdf', {
                                            //    pdfGuid: data.pdfGuid,
                                            //    userId: data.userId,
                                            //    orderNumber: data.orderNumber
                                            //});
                                        }
                                    });
                                }
                                else {
                                    var url = this.getPdfUrl(data).url;
                                    window.open(url);
                                    //this.$store.commit('fontorder/getPdf', {
                                    //    pdfGuid: data.pdfGuid,
                                    //    userId: data.userId,
                                    //    orderNumber: data.orderNumber
                                    //});
                                }
                            }
                        }

                    }, "查看PDF"),
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                        },
                        style: {
                            marginTop: '5px',
                            width: '68px',
                            height: '30px',
                            display: (packageStatus == "未收货" || packageStatus == "已收货" && orderStatus == "正常") && productOrderStatusName != "已取消" ? "inline-block" : "none",
                        },
                        on: {
                            click: () => {
                                this.Newpacked(data);
                            }
                        }

                    }, "打包")
                ]);
            }
        }
    ]

    async created() {
        this.getpage();
        this.getData();
    }
    async mounted() {
    }
}
